<template>
  <BCard class="pb-0 text-[#0A0A0A]">
    <BRow class="gap-[8px]">
      <BCol md="8">
        <BFormGroup
          label-cols-md="3"
          label-class="font-medium !text-[14px]"
          label="Nama role"
        >
          <ValidationProvider
            #default="{ errors }"
            name="Nama Role"
            rules="required|max:30"
          >
            <BFormInput
              :value="name"
              type="text"
              placeholder="Masukkan Nama Role"
              class="max-w-[344px]"
              :state="errors.length > 0 ? false : null"
              @input="$emit('update:name', $event)"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </ValidationProvider>
        </BFormGroup>
      </BCol>
      <BCol md="12">
        <BFormGroup label-class="!pb-[24px]">
          <template #label>
            <b class="text-[14px] font-medium">Menu Yang bisa digunakan</b>
            <p class="mt-[12px] mb-0 text-[12px]">
              Custom role access untuk admin, management , dan mitra
            </p>
          </template>
          <div class="input-group-merge flex w-full">
            <div
              class="contain-form flex flex-col w-full border rounded-[12px]"
            >
              <div class="py-[12px] px-[24px] border-b">
                <BFormCheckbox
                  v-model="selectAll"
                  class="cursor-pointer [&>*]:cursor-pointer"
                  @change="checkAll($event)"
                >
                  <span class="ml-[12px] text-sm font-medium">Semua Akses</span>
                </BFormCheckbox>
              </div>
              <div class="flex flex-col gap-[24px] custom-scroll overflow-y-auto h-[calc(100vh-450px)] p-[24px] bg-[#f5f5f5]">
                <div
                  v-for="(menu, i) in menus"
                  :key="i"
                  class="flex flex-col gap-[12px]"
                >
                  <span class="text-xs">{{ menu.name }}</span>
                  <template v-if="menu.sub_menu.length > 0">
                    <BFormCheckbox
                      v-for="(child, idx) in menu.sub_menu"
                      :key="`${i}-${idx}`"
                      v-model="menuSelected"
                      :value="child.id"
                      class="cursor-pointer [&>*]:cursor-pointer"
                      @input="updateMenuSelected()"
                    >
                      <span class="ml-[12px] text-sm font-medium">{{ child.name }}</span>
                    </BFormCheckbox>
                  </template>
                  <BFormCheckbox
                    v-else
                    v-model="menuSelected"
                    :value="menu.id"
                    class="cursor-pointer [&>*]:cursor-pointer"
                    @input="updateMenuSelected()"
                  >
                    <span class="ml-[12px] text-sm font-medium">{{ menu.name }}</span>
                  </BFormCheckbox>
                </div>
              </div>
            </div>
          </div>
          <div class="input-group-merge flex w-full mt-[24px]">
            <div
              class="contain-form flex flex-col w-full border rounded-[12px]"
            >
              <div class="flex w-full py-[12px] px-[24px] gap-[12px] border-b">
                <span class="flex font-medium text-sm">Akses Live Chat</span>
              </div>
              <div class="flex flex-col gap-[24px] p-[24px] bg-[#f5f5f5]">
                <div
                  v-for="(menu, i) in liveChatMenus"
                  :key="i"
                  class="flex flex-col gap-[12px]"
                >
                  <span class="text-xs">{{ menu.name }}</span>
                  <BFormRadio
                    v-for="(child, idx) in menu.sub_menu"
                    :key="`${i}-${idx}`"
                    v-model="liveChatMenuSelectedProxy"
                    :name="menu.name"
                    :value="child.id"
                    class="cursor-pointer [&>*]:cursor-pointer"
                  >
                    <span class="ml-[12px] text-sm font-medium">{{ child.name }}</span>
                  </BFormRadio>
                </div>
              </div>
            </div>
          </div>
        </BFormGroup>
      </Bcol>
    </BRow>
  </BCard>
</template>

<script>
import { komtimAxiosIns } from '@/libs/axios'
import { alertError } from '@toast'
import { ValidationProvider } from 'vee-validate'
import {
  max,
} from '@validations'
import { BFormRadio } from 'bootstrap-vue'

export default {
  components: {
    ValidationProvider,
  },
  props: {
    name: {
      type: String,
      default: '',
    },
    selected: {
      type: Array,
      default: () => [],
    },
    liveChatMenuSelected: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      max,
      showPassword: false,
      showConfirmPassword: false,
      alertError,
      menus: [],
      liveChatMenus: [],
      allMenuExist: [],
      menuSelected: [],
      selectAll: false,
    }
  },
  computed: {
    liveChatMenuSelectedProxy: {
      get() {
        return this.liveChatMenuSelected
      },
      set(val) {
        this.$emit('update:liveChatMenuSelected', val)
      },
    },
  },
  watch: {
    selected(newVal) {
      this.menuSelected = newVal
      this.selectAll = newVal.length === this.allMenuExist.length
    },
  },
  beforeMount() {
    this.getListData()
  },
  methods: {
    async getListData() {
      const url = 'v1/menu_access'
      await komtimAxiosIns
        .get(url)
        .then(res => {
          const { data } = res.data
          this.menus = data.all_access
          this.liveChatMenus = data.live_chat_access
          this.$emit('update:liveChatMenuSelected', data.live_chat_access[0].sub_menu[0].id ?? null)

          data.all_access.forEach(e => {
            this.allMenuExist.push(e.id)
            if (e.sub_menu.length) {
              e.sub_menu.forEach(el => this.allMenuExist.push(el.id))
            }
          })
        })
        .catch(err => {
          this.loading = false
          this.alertError(err)
        })
    },
    updateMenuSelected() {
      this.$emit('update:menuSelected', this.menuSelected)
    },
    checkAll(event) {
      if (event) {
        this.menuSelected = this.allMenuExist
        this.$emit('update:menuSelected', this.menuSelected)
      } else {
        this.menuSelected = []
        this.$emit('update:menuSelected', this.menuSelected)
      }
    },
  },
}
</script>
